import { render, staticRenderFns } from "./AccreditationNew.vue?vue&type=template&id=71e9902c&scoped=true&"
import script from "./AccreditationNew.vue?vue&type=script&lang=js&"
export * from "./AccreditationNew.vue?vue&type=script&lang=js&"
import style0 from "./AccreditationNew.vue?vue&type=style&index=0&id=71e9902c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71e9902c",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {UIDiacritics: require('/opt/build/repo/components/UI/Diacritics.vue').default,CardsAccreditation: require('/opt/build/repo/components/Cards/Accreditation.vue').default,CoursesReviews: require('/opt/build/repo/components/Courses/Reviews.vue').default})
